import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { EjercicioByRange } from "../../../Finanzas/Helper/EjercicioByRange";

const MESES = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];

// Filtro de Objetivos Mensuales — mismo patrón modal (botón + PlantillaScreen + show/hide por id)
// que FiltroReporteClientesActualizados, recortado a solo Ejercicio y Mes: aquí no aplican
// región/sucursal/etiqueta. Reutiliza las clases .rca-filtro-* ya existentes (_CRM_Reportes.scss),
// incluyendo el modificador "sinadr" para el ancho compacto sin las columnas de región/sucursal.
export const FiltroObjetivosMensuales = ({ onCargar, ejercicio, mes }) => {
  const [openModal, setOpenModal] = useState(false);
  const [filtro, setFiltro] = useState({ ejercicio, mes });

  const onOpenModal = () => {
    const container = document.getElementById("objFiltrosObjetivos-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onChangeMes = ({ target }) => setFiltro((prev) => ({ ...prev, mes: Number(target.value) }));

  const handleCargar = () => {
    if (!filtro.ejercicio) {
      Swal.fire("OBJETIVOS MENSUALES", "Selecciona el ejercicio para continuar", "warning");
      return;
    }
    onOpenModal();
    onCargar(filtro.ejercicio, filtro.mes);
  };

  return (
    <div className="rca-filtro">
      <button type="button" className="rca-filtro-btn" onClick={onOpenModal} aria-label="Filtrar">
        <FilterAltIcon /> <span className="crm-btn-label">Filtrar</span>
      </button>

      <div className="rca-filtro-modal" id="objFiltrosObjetivos-modal">
        <PlantillaScreen titulo="Filtro" className_main={1} className="rca-filtro-modal-plantilla sinadr">
          <div className="rca-filtro-modal-close" onClick={onOpenModal}>
            X
          </div>

          <div className="rca-filtro-modal-body">
            <div className="rca-filtro-modal-filtros">
              <div className="rca-filtro-tiempo">
                <div className="rca-filtro-group-B">
                  <label>Ejercicio</label>
                  <EjercicioByRange
                    name="ejercicio"
                    value={filtro.ejercicio}
                    onChange={(e) => setFiltro((prev) => ({ ...prev, ejercicio: Number(e.target.value) }))}
                  />
                </div>

                <div className="rca-filtro-group">
                  <label>Mes</label>
                  <select name="mes" value={filtro.mes} onChange={onChangeMes} className="rca-filtro-select">
                    {MESES.map((m) => (
                      <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                  </select>
                </div>

                <div className="rca-filtro-btn-cargar" onClick={handleCargar}>
                  Cargar
                </div>
              </div>
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
